<template>
  <ForgotPasswordSent />
</template>

<script>
import ForgotPasswordSent from '../components/templates/ForgotPasswordSent'

export default {
  components: {
    ForgotPasswordSent
  }
}
</script>
